<!-- 메인 -->
<template>
  <div class="stopusing-detail-wrap">
    <div class="order-text-box registration">
      <strong>이마티콘 비밀번호 입력</strong>
      <input type="password" inputmode="numeric" pattern="[0-9]*" placeholder="숫자 6자리 입력 (중복 불가능)" v-model="mberPassword" maxlength="6" oninput="this.value = this.value.replace(/[^0-9]/ig, '')"/>
    </div>
    <div class="order-text-box registration">
      <strong>이마티콘 비밀번호 확인</strong>
      <input type="password" inputmode="numeric" pattern="[0-9]*" placeholder="숫자 6자리 입력 (중복 불가능)" v-model="mberPasswordCheck" maxlength="6" oninput="this.value = this.value.replace(/[^0-9]/ig, '')"/>
      <p class="error">{{ errorMessage }}</p>
    </div>
    <div class="fixed">
      <div class="button-wrap">
        <button type="button" class="button-bg-yellow" @click="saveMberPassword">저장하기</button>
      </div>
    </div>
    <alert-popup v-if="showAlertPopup === true" @confirmPopupClickConfirm="showAlertPopup = false" :message="alertMessage" />
    <page-popup v-if="showPagePopup === true" @confirmPopupClickConfirm="$router.push({ name: 'home' })" :message="alertMessage" />
    <text-alert-popup v-if="showTextPopup === true" @confirmPopupClickConfirm="$router.push({ name: 'setting', params: { savePassword: 'Y' } })" :message="alertMessage" />
  </div>
</template>
<script>
import apiList from '@/api/apiList';
import PasswordAlertPopup from '@/views/myemarticon/passwordAlertPopup.vue';
import TextAlertPopup from '@/views/myemarticon/textAlertPopup.vue';

export default {
  name: 'emarticonMberPassword',
  components: { TextAlertPopup, 'alert-popup': PasswordAlertPopup, 'page-popup': PasswordAlertPopup },
  data() {
    return {
      mberPassword: '',
      mberPasswordCheck: '',
      showAlertPopup: false,
      showPagePopup: false,
      showTextPopup: false,
      alertMessage: '',
      errorMessage: '',
    };
  },
  mounted() {
    this.$heading('비밀번호 설정');
    if (!this.$route.params.certInfo) {
      this.showPagePopup = true;
      this.alertMessage = '잘못된 경로로 접근하였습니다.';
    }

    // Todo 안드로이드 뒤로가기 제어
    // if (this.$store.state.nativeStore.device === "and") {
    //   window.location.href = 'emart-today://goback/?enable=N'; // 뒤로가기 미허용
    // }
  },
  watch: {
    mberPasswordCheck(value) {
      if (value !== this.mberPassword) {
        this.errorMessage = '비밀번호가 일치하지 않습니다.';
      } else {
        this.errorMessage = '';
      }
    },
    mberPassword(value) {
      if (this.mberPasswordCheck && value !== this.mberPasswordCheck) {
        this.errorMessage = '비밀번호가 일치하지 않습니다.';
      } else {
        this.errorMessage = '';
      }
    },
  },
  methods: {
    /**
     * 이마티콘 회원 비밀번호 저장 API 호출
     */
    async saveMberPassword() {
      if (!this.$validate()) return;
      try {
        const res = await apiList.postMberPassword({ emarticonPassword: this.mberPassword });
        if (res.data.status !== 200) {
          throw new Error(res.data.message);
        }
        this.alertMessage = '비밀번호가 설정되었습니다.';
        this.showTextPopup = true;
      } catch (error) {
        console.error(error);
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호를 설정하지 못했습니다.';
        return false;
      }
    },
    /**
     * 이마티콘 회원 비밀번호 유효성 검사
     */
    $validate() {
      // 비밀번호 입력 여부 검증
      if (this.mberPassword.trim().length === 0) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호를 입력해 주세요.';
        return false;
      }

      // 비밀번호 확인 입력 여부 검증
      if (this.mberPasswordCheck.trim().length === 0) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호 확인을 입력해 주세요.';
        return false;
      }

      // 비밀번호 확인과 비밀번호 일치 여부 검증
      if (this.mberPassword !== this.mberPasswordCheck) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호가 일치하지 않습니다.';
        return false;
      }

      let regex;
      // 0-9 6자리 숫자만 사용 가능
      regex = /^\d{6}$/;
      if (!regex.test(this.mberPassword)) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호를 6자리 숫자로 입력해 주세요.';
        return false;
      }

      // 6자리 모두 연속된 번호 사용 불가능
      regex = /012345|123456|234567|345678|456789|987654|876543|765432|654321|543210/;
      if (regex.test(this.mberPassword)) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호는 연속된 6자리 숫자로<br> 설정할 수 없습니다.';
        return false;
      }

      // 동일한 번호 6개 사용 불가능
      regex = /^(.)\1{5}$/;
      if (regex.test(this.mberPassword)) {
        this.showAlertPopup = true;
        this.alertMessage = '비밀번호는 동일한 6자리 숫자로<br> 설정할 수 없습니다.';
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/home/emarticonRegistration.scss';
</style>
